import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import { Table, Input, Tooltip as AntdTooltip, Button as AntdButton } from 'antd';
import { CodeOutlined } from '@ant-design/icons';
import CloseIcon from '@mui/icons-material/Close';
import CodeIcon from '@mui/icons-material/Code';
import DQAgentCustomRuleModal from './DQAgentCustomRuleModal';
import DQAgentPredefinedRuleModal from './DQAgentPredefinedRuleModal';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
};

const columns = (handleOpenUdfModal) => [
  {
    title: 'Rule',
    dataIndex: 'rule',
    key: 'rule',
    // align: 'left',
    render: (text) => (
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        value={text}
        disabled
        sx={{
          // marginLeft: '10px',
          // marginRight: '10px',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'black',
            },
            '&:hover fieldset': {
              borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'black',
            },
          },
          '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: 'black', // Ensures text is black even when disabled
          },
          '& .MuiInputLabel-root.Mui-disabled': {
            color: 'black', // Label color when disabled
          },
        }}
      />
    ),
  },
  {
    title: 'Code',
    key: 'action',
    width: 60,
    align: 'center',
    render: (_, record) => (
      <Tooltip title="Open code snippet">
        <IconButton onClick={() => handleOpenUdfModal(record.code)}>
          <CodeIcon />
        </IconButton>
      </Tooltip>
    ),
  },
];

function DataQualityAgentFinalRules({ data, disableForm }) {
  const [ruleAndCodeList, setRuleAndCodeList] = useState([]);
  const [openUdfModal, setOpenUdfModal] = useState(false);
  const [udfCode, setUdfCode] = useState('');
  const [openCustomRuleModal, setOpenCustomRuleModal] = useState(false);
  const [openPredefinedRuleModal, setOpenPredefinedRuleModal] = useState(false);
  const handleOpenCustomRuleModal = () => setOpenCustomRuleModal(true);
  const handleCloseCustomRuleModal = () => setOpenCustomRuleModal(false);
  const handleOpenPredefinedRuleModal = () => setOpenPredefinedRuleModal(true);
  const handleClosePredefinedRuleModal = () => setOpenPredefinedRuleModal(false);

  const dataSource = ruleAndCodeList.map((item, index) => ({
    key: index,
    ...item,
  }));

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  const paginatedData = dataSource.slice(
    (pagination.current - 1) * pagination.pageSize,
    pagination.current * pagination.pageSize
  );

  const handleOpenUdfModal = (text) => {
    setUdfCode(text);
    setOpenUdfModal(true);
  };

  const handleCloseUdfModal = () => {
    setOpenUdfModal(false);
  };

  const getRuleCode = () => {
    const rules = data.filter((item) => item.type === 'rule').map((item) => item.message);
    const codes = data.filter((item) => item.type === 'code').map((item) => item.message);

    const combined = rules.map((rule, i) => ({
      rule,
      code: codes[i] || '',
    }));

    setRuleAndCodeList(combined);
  };

  useEffect(() => {
    getRuleCode();
  }, []);

  return (
    <div>
      <Table
        columns={columns(handleOpenUdfModal)}
        dataSource={paginatedData}
        rowKey="key"
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: dataSource.length, // Required for proper pagination count
        }}
        onChange={handleTableChange}
        bordered={false}
        components={{
          body: {
            row: (props) => <tr {...props} style={{ borderBottom: 'none' }} />,
            cell: (props) => <td {...props} style={{ borderBottom: 'none', padding: '4px 6px' }} />,
          },
        }}
      />

      {/* {ruleAndCodeList.map((item, idx) => (
        <React.Fragment key={idx}>
          <Box display="flex" alignItems="center" sx={{ my: 2 }}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={item.rule}
              disabled
              sx={{
                marginLeft: '10px',
                marginRight: '10px',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'black',
                  },
                  '&:hover fieldset': {
                    borderColor: 'black',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'black',
                  },
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black', // Ensures text is black even when disabled
                },
                '& .MuiInputLabel-root.Mui-disabled': {
                  color: 'black', // Label color when disabled
                },
              }}
            />
            <Tooltip title="Open code snippet">
              <IconButton onClick={() => handleOpenUdfModal(item.code)}>
                <CodeIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </React.Fragment>
      ))} */}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button
          variant="contained"
          sx={{
            display: 'flex',
            marginTop: '8px',
            alignContent: 'flex-start',
            backgroundColor: '#00043C',
            '&:hover': { backgroundColor: '#00043C' },
            marginLeft: '17px',
          }}
          onClick={handleOpenCustomRuleModal}
          disabled={disableForm}
        >
          Add Custom Rules
        </Button>
        <Button
          variant="contained"
          sx={{
            display: 'flex',
            marginTop: '8px',
            alignContent: 'flex-start',
            backgroundColor: '#00043C',
            '&:hover': { backgroundColor: '#00043C' },
            marginLeft: '17px',
          }}
          onClick={handleOpenPredefinedRuleModal}
          disabled={disableForm}
        >
          Add Predefined Rules
        </Button>
      </div>
      {openCustomRuleModal && (
        <DQAgentCustomRuleModal open={openCustomRuleModal} handleClose={handleCloseCustomRuleModal} />
      )}
      {openPredefinedRuleModal && (
        <DQAgentPredefinedRuleModal open={openPredefinedRuleModal} handleClose={handleClosePredefinedRuleModal} />
      )}

      <Modal open={openUdfModal} onClose={handleCloseUdfModal}>
        <Box sx={modalStyle}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">UDF (User Defined Function)</Typography>
            <IconButton onClick={handleCloseUdfModal} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">Code:</Typography>
            <Box
              sx={{
                maxHeight: '250px',
                overflowY: 'auto',
                backgroundColor: '#f5f5f5',
                borderRadius: '4px',
                padding: '10px',
              }}
            >
              <pre
                style={{
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  padding: '10px',
                  whiteSpace: 'pre-wrap',
                  overflow: 'auto',
                  fontFamily: 'monospace',
                }}
              >
                {udfCode}
              </pre>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default DataQualityAgentFinalRules;
